module.exports = __webpack_public_path__ + "static/media/feb1120193.7a773c8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feb1120193.png
// module id = 253
// module chunks = 0